import { render } from "./StrokedSafeIcon.vue?vue&type=template&id=d5c884a4"
import script from "./StrokedSafeIcon.vue?vue&type=script&lang=js"
export * from "./StrokedSafeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__